// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

import {
    getAuth,
    User
} from "firebase/auth";
import {
    getFirestore,
    doc,
    collection,
    addDoc,
    updateDoc,
    deleteDoc,
    serverTimestamp,
    DocumentReference,
    Timestamp
} from "firebase/firestore";
import {
    getStorage,
    ref as storageRef,
    uploadBytes,
    getDownloadURL,
    deleteObject
} from "firebase/storage";
import "firebase/firestore"
import SECRETS from "./../../SECRETS/secrets.json"


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
export const FLAVOR = import.meta.env.VITE_FLAVOR || process.env.VITE_FLAVOR
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
export const SECRETS_ENV: any = SECRETS[FLAVOR as keyof typeof SECRETS]

const firebaseConfig = {

    apiKey: SECRETS_ENV.FIREBASE_API_KEY,
    authDomain: SECRETS_ENV.AUTH_DOMAIN,
    projectId: SECRETS_ENV.PROJECT_ID,
    storageBucket: SECRETS_ENV.STORAGE_BUCKET,
    messagingSenderId: SECRETS_ENV.MESSAGING_SENDER_ID,
    appId: SECRETS_ENV.APP_ID,
    measurementId: SECRETS_ENV.MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize App Check with optimized settings for fewer captcha challenges
if (typeof window !== 'undefined') {
    try {
      const siteKey = SECRETS_ENV.FIREBASE_RECAPTCHA_SITE_KEY || SECRETS_ENV.CAPTCHA;
      const currentDomain = window.location.hostname;
      const projectId = SECRETS_ENV.PROJECT_ID;
      const isLocalhost = ['localhost', '127.0.0.1', '::1'].includes(currentDomain);
      // Optional switch to disable App Check while developing locally
      // Defaults to false to preserve existing behavior
      const disableAppCheckOnLocal = (import.meta as any)?.env?.VITE_DISABLE_APPCHECK_LOCAL === 'TRUE' || (process as any)?.env?.VITE_DISABLE_APPCHECK_LOCAL === 'TRUE';
      
      // Only initialize App Check if we have a valid site key
      if (isLocalhost && disableAppCheckOnLocal) {
        console.warn('⚠️ Firebase App Check disabled on localhost (VITE_DISABLE_APPCHECK_LOCAL=TRUE).');
      } else if (siteKey) {
        console.log('🔍 AppCheck Configuration Debug:');
        console.log('Project ID:', projectId);
        console.log('Current Domain:', currentDomain);
        console.log('Site Key (first 15 chars):', siteKey?.substring(0, 15) + '...');
        console.log('Site Key Type:', siteKey?.startsWith('6L') ? 'Likely reCAPTCHA Enterprise' : 'Unknown format');
        
        if (projectId !== 'coachprodev') {
          console.warn('⚠️ Project ID mismatch detected!');
          console.log('Expected: coachprodev, Got:', projectId);
        }
        
        // Initialize App Check with optimized settings to reduce reCAPTCHA challenges
        initializeAppCheck(app, {
          provider: new ReCaptchaEnterpriseProvider(siteKey),
          isTokenAutoRefreshEnabled: true
        });
        
        console.log('✅ Firebase App Check initialized with reCAPTCHA Enterprise');
      } else {
        console.warn('⚠️ reCAPTCHA Enterprise site key not found - App Check disabled');
        console.log('This is normal for development environments');
      }
    } catch (error) {
      console.error('❌ Failed to initialize App Check:', error);
      console.log('🛠️ Common fixes:');
      console.log('1. Verify reCAPTCHA Enterprise site key in Google Cloud Console');
      console.log('2. Check domain whitelist includes:', window.location.hostname);
      console.log('3. Ensure Firebase project matches Google Cloud project');
      console.log('4. Verify AppCheck is enabled in Firebase Console');
      console.log('⚠️ App Check disabled - some Firebase features may be limited');
    }
  }
  
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Export Firebase utility functions
export const firebase = {
    // Firestore utilities
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    collection,
    serverTimestamp,
    
    // Storage utilities
    storageRef,
    uploadBytes,
    getDownloadURL,
    deleteObject,
    
    // Types
    Timestamp,
    DocumentReference
};

// Utility function to check if zoom is enabled for a service provider
export const isZoomEnabledForProvider = (): boolean => {
    // Zoom is now enabled for all providers
    return true;
};

export type {
    User,
    DocumentReference
};